import { render, staticRenderFns } from "./NewIncidentForm.vue?vue&type=template&id=63413a65&scoped=true&"
import script from "./NewIncidentForm.vue?vue&type=script&lang=ts&"
export * from "./NewIncidentForm.vue?vue&type=script&lang=ts&"
import style0 from "./NewIncidentForm.vue?vue&type=style&index=0&id=63413a65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63413a65",
  null
  
)

export default component.exports